import { initializeTable } from '../tables';

export function initializeNotificationLogsTable() {
    const rootElement = document.querySelector('#notificationLogsTable');
    if (!rootElement) return;

    const filtersElement = document.querySelector('#notificationLogsFilters');
    const ajaxURL = rootElement.dataset.ajaxUrl;
    const pillsContainerSelector = '.active-filters-container';

    const columns = [
        { title: '#', formatter: 'rownum', width: 60, headerSort: false },
        {
            title: gettext('Kategoria'),
            field: 'notification.target_type',
            width: 150,
            hozAlign: 'left',
            headerSort: true,
            formatter: function (cell) {
                const value = cell.getValue();
                const targetTypeLabels = {
                    DOC: gettext('Dokument'),
                    TIP_M: gettext('Ściąga: Oznaczenia'),
                    TIP_D: gettext('Ściąga: Wymiary'),
                    TIP_W: gettext('Ściąga: Odpady'),
                    TIP_S: gettext('Ściąga: Słownik'),
                    TIP_C: gettext('Ściąga: Klasyfikacja'),
                    GEN: gettext('Ogólne'),
                };
                return targetTypeLabels[value] || value || '-';
            },
        },
        {
            title: gettext('Tytuł'),
            field: 'notification.subject',
            minWidth: 200,
            widthGrow: 5,
            headerSort: true,
            formatter: 'textarea',
        },
        {
            title: gettext('Użytkownik'),
            field: 'user.username',
            minWidth: 275,
            widthGrow: 2,
            headerSort: true,
            formatter: function (cell) {
                return cell.getValue() || '-';
            },
        },
        {
            title: gettext('Data publikacji'),
            field: 'notification.created_at',
            widthGrow: 1,
            headerSort: true,
            formatter: 'datetime',
            formatterParams: {
                inputFormat: 'iso',
                outputFormat: 'dd.MM.yyyy HH:mm',
            },
            sorter: 'datetime',
            sorterParams: {
                format: 'iso',
                alignEmptyValues: 'top',
            },
        },
        {
            title: gettext('Data odczytania'),
            field: 'read_at',
            widthGrow: 1,
            headerSort: true,
            formatter: 'datetime',
            formatterParams: {
                inputFormat: 'iso',
                outputFormat: 'dd.MM.yyyy HH:mm',
                invalidPlaceholder: '-',
            },
            sorter: 'datetime',
            sorterParams: {
                format: 'iso',
                alignEmptyValues: 'top',
            },
        },
        {
            title: gettext('Status'),
            field: 'read',
            width: 130,
            hozAlign: 'center',
            headerSort: true,
            formatter: function (cell) {
                const isRead = cell.getValue();
                const text = isRead
                    ? gettext('Przeczytane')
                    : gettext('Nieprzeczytane');
                return text;
            },
        },
    ];

    const table = initializeTable({
        tableElement: rootElement,
        filtersElement: filtersElement,
        ajaxURL: ajaxURL,
        columns: columns,
        pillsConfig: {
            containerSelector: pillsContainerSelector,
        },
        initialSort: [{ field: 'notification.created_at', dir: 'desc' }],
    });

    const exportBtn = document.querySelector('#exportNotificationLogs');
    if (exportBtn) {
        exportBtn.addEventListener('click', () => {
            const filters = table.getFilters();
            const sorters = table.getSorters();
            const urlParams = new URLSearchParams();

            if (sorters.length > 0) {
                const order =
                    sorters[0].dir === 'asc'
                        ? sorters[0].field
                        : `-${sorters[0].field}`;
                urlParams.append('order', order.replaceAll('.', '__'));
            }

            filters.forEach((f) => {
                if (f.value && (f.value.start || f.value.end)) {
                    if (f.value.start) {
                        urlParams.append(
                            `${f.field.replaceAll('.', '__')}__gte`,
                            f.value.start,
                        );
                    }
                    if (f.value.end) {
                        urlParams.append(
                            `${f.field.replaceAll('.', '__')}__lte`,
                            f.value.end,
                        );
                    }
                } else if (f.value !== undefined && f.value !== '') {
                    urlParams.append(f.field.replaceAll('.', '__'), f.value);
                }
            });

            const exportUrl = `${ajaxURL}export/?${urlParams.toString()}`;
            window.location.href = exportUrl;
        });
    }

    const filter_btn = document.querySelector('.filter-btn');
    if (filter_btn) {
        window.tables.initializeTableFilter();
        const filtersContainer = document.querySelector(
            '#notificationLogsFilters .form-fields',
        );
        if (filtersContainer) {
            window.utils.hideOnClickOutside(filtersContainer, filter_btn);
        }
    }

    return table;
}

export default initializeNotificationLogsTable;
